import { useState } from "react";
import { privacyPolicy, termsOfService } from "./privacyPolicy";

function LegalDocument({ title, content, onBack }) {
  return (
    <div className="max-w-3xl mx-auto h-full overflow-y-auto">
      <div className="sticky top-0 bg-white dark:bg-neutral-900 border-b border-neutral-200 dark:border-neutral-700 px-2 py-3 flex items-center gap-2">
        <button
          onClick={onBack}
          className="flex items-center justify-center w-9 h-9 shrink-0 rounded-full text-neutral-700 dark:text-neutral-200 hover:bg-neutral-100 dark:hover:bg-neutral-800 active:opacity-60 touch-manipulation transition-colors"
          aria-label="Back"
        >
          <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
          </svg>
        </button>

        <h1 className="text-xl font-semibold">{title}</h1>
      </div>

      <div className="p-6 text-sm leading-7 text-neutral-700 dark:text-neutral-300 whitespace-pre-wrap">
        {content.trim()}
      </div>
    </div>
  );
}

export default function About({ onBack }) {
  const [view, setView] = useState("about"); // "about" | "privacy" | "terms"

  if (view === "privacy") {
    return (
      <LegalDocument
        title="Privacy Policy"
        content={privacyPolicy}
        onBack={() => setView("about")}
      />
    );
  }

  if (view === "terms") {
    return (
      <LegalDocument
        title="Terms of Service"
        content={termsOfService}
        onBack={() => setView("about")}
      />
    );
  }

  return (
    <div className="max-w-3xl mx-auto h-full overflow-y-auto">
      <div className="sticky top-0 bg-white dark:bg-neutral-900 border-b border-neutral-200 dark:border-neutral-700 px-2 py-3 flex items-center gap-2">
        <button
          onClick={onBack}
          className="flex items-center justify-center w-9 h-9 shrink-0 rounded-full text-neutral-700 dark:text-neutral-200 hover:bg-neutral-100 dark:hover:bg-neutral-800 active:opacity-60 touch-manipulation transition-colors"
          aria-label="Back"
        >
          <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
          </svg>
        </button>

        <h1 className="text-xl font-semibold">
          About Metisel
        </h1>
      </div>

      <div className="p-6 space-y-6 text-sm leading-7 text-neutral-700 dark:text-neutral-300">

        <section>
          <h2 className="text-lg font-semibold mb-2">
            Welcome to Metisel
          </h2>

          <p>
            Metisel is a social communication platform that combines
            social networking, private messaging, digital assets,
            and peer-to-peer commerce into one seamless experience.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">
            Feed
          </h2>

          <p>
            Share posts, photos, videos, and updates with your
            community. Discover content from people you follow,
            engage through comments, reposts, reactions, and
            support creators.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">
            Chat
          </h2>

          <p>
            Communicate through private and group conversations,
            exchange media, and enjoy end-to-end encrypted
            messaging designed to keep your conversations secure.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">
            P2P Marketplace
          </h2>

          <p>
            Buy and sell digital assets directly with other users
            through a secure peer-to-peer marketplace with integrated
            chat and order management.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">
            Digital Assets
          </h2>

          <p>
            Manage supported assets, view balances, send and receive
            funds, and monitor transaction history from a unified
            wallet interface.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">
            Privacy & Security
          </h2>

          <p>
            Security is a core part of Metisel. Private conversations
            are protected with end-to-end encryption, while platform
            services are designed to safeguard user accounts and
            digital assets.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">
            Our Mission
          </h2>

          <p>
            To build a trusted platform where communication,
            community, and digital commerce come together, enabling
            people everywhere to connect and exchange value with
            confidence.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">
            Legal
          </h2>

          <div className="flex flex-col gap-2">
            <button
              onClick={() => setView("terms")}
              className="text-left px-4 py-3 rounded-lg border border-neutral-200 dark:border-neutral-700 hover:bg-neutral-50 dark:hover:bg-neutral-800 flex items-center justify-between"
            >
              <span>Terms of Service</span>
              <span className="opacity-50">→</span>
            </button>

            <button
              onClick={() => setView("privacy")}
              className="text-left px-4 py-3 rounded-lg border border-neutral-200 dark:border-neutral-700 hover:bg-neutral-50 dark:hover:bg-neutral-800 flex items-center justify-between"
            >
              <span>Privacy Policy</span>
              <span className="opacity-50">→</span>
            </button>
          </div>
        </section>

        <div className="pt-6 border-t border-neutral-200 dark:border-neutral-700 text-center text-neutral-500">
          <p className="font-medium">Metisel Social</p>
          <p>Version 1.0.0</p>
          <p>© {new Date().getFullYear()} Metisel. All rights reserved.</p>
        </div>

      </div>
    </div>
  );
}